(function() {
  // Wait for DOM to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOriginalPriceTracking);
  } else {
    initOriginalPriceTracking();
  }

  function initOriginalPriceTracking() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    // Get product data
    const productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;
    
    const product = JSON.parse(productJson.textContent);
    
    // Listen for variant changes
    productForm.addEventListener('change', function(e) {
      // Check if it's a variant selector change
      if (e.target.name === 'id' || e.target.closest('[name="id"]')) {
        updateOriginalPrice(productForm, product);
      }
    });

    // Also listen for custom variant change events (some themes use these)
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        updateOriginalPriceWithVariant(productForm, e.detail.variant);
      }
    });
  }

  function updateOriginalPrice(form, product) {
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    const variant = product.variants.find(v => v.id == variantId);
    if (variant) {
      updateOriginalPriceWithVariant(form, variant);
    }
  }

  function updateOriginalPriceWithVariant(form, variant) {
    // Check if variant has compare_at_price and it's higher than price
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const originalPrice = (variant.compare_at_price / 100).toFixed(2);
      const salePrice = (variant.price / 100).toFixed(2);
      const discountAmount = (originalPrice - salePrice).toFixed(2);
      const discountPercentage = Math.round((discountAmount / originalPrice) * 100);
      
      // Update or create all three fields
      updateOrCreateField(form, 'original-price-field', 'properties[_Original_Price]', originalPrice);
      updateOrCreateField(form, 'discount-amount-field', 'properties[_Discount_Amount]', discountAmount);
      updateOrCreateField(form, 'discount-percentage-field', 'properties[_Discount_Percentage]', discountPercentage + '%');
    } else {
      // If no compare_at_price, remove all fields
      removeField(form, 'original-price-field');
      removeField(form, 'discount-amount-field');
      removeField(form, 'discount-percentage-field');
    }
  }

  function updateOrCreateField(form, fieldId, fieldName, value) {
    let field = form.querySelector('#' + fieldId);
    
    if (field) {
      // Field exists, update it
      field.value = value;
    } else {
      // Field doesn't exist, create it
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = fieldName;
      field.value = value;
      field.id = fieldId;
      
      // Add it to the form
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.parentNode.insertBefore(field, submitButton);
      } else {
        form.appendChild(field);
      }
    }
  }

  function removeField(form, fieldId) {
    const field = form.querySelector('#' + fieldId);
    if (field) {
      field.remove();
    }
  }
})();